import React from 'react';
import { Container, Tab, Tabs } from 'react-bootstrap';
import Cards from './Cards.js';
import People from './People.js';
import About from './About.js';
import Sangha from './Sangha.js';

function Explore() {
  return (
    <Container>
        <Tabs
          defaultActiveKey="people"
          className="custom-navbar custom-tabs"
          justify
        >
          <Tab eventKey="people" title="People">
            <People />
          </Tab>
          <Tab eventKey="sangha" title="Sanghas">
            <Sangha />
          </Tab>
          <Tab eventKey="cards" title="Cards">
            <Cards />
          </Tab>
          <Tab eventKey="about" title="About">
            <About />
          </Tab>
        </Tabs>
    </Container>
  );
}

export default Explore;
